module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/facility-566311a885a9f3f531a1ada9f7a97220.webp";